import { Box, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Text, useDisclosure } from "@chakra-ui/react";
import { AuthContext } from "contexts/AuthContext";
import React, { useContext, useEffect, useState } from "react";
import { useStorage } from "hooks/useStorage";

export default function VideoPlayer({content, trigger}) {

  const { user } = useContext(AuthContext)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { getUrl } = useStorage({user})

  const [source, setSource] = useState()

  // The URL is fetched when the player is opened, not for every row on screen
  // (the selection lists show up to 200 items per page). A missing file shows a
  // message instead of an unhandled error.
  useEffect(() => {
    if (!isOpen || source) return
    let active = true
    getUrl(content)
      .then(url => active && setSource(url))
      .catch(() => active && setSource(null))
    return () => { active = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, content.id])

  return (
    <>
      <Box onClick={onOpen}>
        {trigger}
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalBody p={source ? 0 : 6}>
            {source === undefined && <Spinner />}
            {source === null && <Text>The file could not be loaded.</Text>}
            {source && ((content.type === 'image')
              ? <img width="100%" alt="" src={source} style={{borderRadius: '0.375rem'}}/>
              : <video controls width="100%" src={source} autoPlay style={{borderRadius: '0.375rem'}}></video>
              )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}